/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import AEFeedbackAlert from "@auex/react-components/FeedbackAlert";
import PropTypes from "prop-types";
import React, {Component} from "react";

export default class Alerts extends Component {
  static contextTypes = {
    __: PropTypes.func.isRequired,
  };

  static defaultProps = {
    errors: [],
  };

  mapErrors = (errors) => {
    const {
      __,
    } = this.context;

    return errors.map(error => {
      if (error.message) {
        return error.message;
      }

      // FIXME: Get this out of here.
      if (error === "invalidLogin") {
        return __("errors::invalidLogin");
      }

      return error;
    });
  };

  render() {
    const {
      errors,
      info,
      permanent,
      success,
      warning,
    } = this.props;

    return (
      <AEFeedbackAlert
        errors={errors.length ? this.mapErrors(errors) : undefined}
        info={info.length ? info : undefined}
        permanent={permanent}
        success={success.length ? success : undefined}
        warnings={warning.length ? warning : undefined}
      />
    );
  }
}



// WEBPACK FOOTER //
// ../render/components/Alerts.jsx